module.exports = __webpack_public_path__ + "62fce2da7953288cc620fa1de46efc50.png";